/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Round_ReadyInputs */

const bn_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রস্তুত`)
};

const de_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit`)
};

const el_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ετοιμος`)
};

const en_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

const es_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo`)
};

const fr_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt`)
};

const hi_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तैयार`)
};

const hu_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kész`)
};

const id_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap`)
};

const it_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto`)
};

const ja_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備ができて`)
};

const ko_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`준비가 된`)
};

const nl_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar`)
};

const pl_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowy`)
};

const pt_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparar`)
};

const ru_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готовый`)
};

const sv_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo`)
};

const tr_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazır`)
};

const uk_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готовий`)
};

const vi_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẵn sàng`)
};

const zh_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备好`)
};

const zh_hant_game_round_ready = /** @type {(inputs: Game_Round_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備好`)
};

/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Game_Round_ReadyInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_round_ready = /** @type {((inputs?: Game_Round_ReadyInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Round_ReadyInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_round_ready(inputs)
	if (locale === "de") return de_game_round_ready(inputs)
	if (locale === "el") return el_game_round_ready(inputs)
	if (locale === "en") return en_game_round_ready(inputs)
	if (locale === "es") return es_game_round_ready(inputs)
	if (locale === "fr") return fr_game_round_ready(inputs)
	if (locale === "hi") return hi_game_round_ready(inputs)
	if (locale === "hu") return hu_game_round_ready(inputs)
	if (locale === "id") return id_game_round_ready(inputs)
	if (locale === "it") return it_game_round_ready(inputs)
	if (locale === "ja") return ja_game_round_ready(inputs)
	if (locale === "ko") return ko_game_round_ready(inputs)
	if (locale === "nl") return nl_game_round_ready(inputs)
	if (locale === "pl") return pl_game_round_ready(inputs)
	if (locale === "pt") return pt_game_round_ready(inputs)
	if (locale === "ru") return ru_game_round_ready(inputs)
	if (locale === "sv") return sv_game_round_ready(inputs)
	if (locale === "tr") return tr_game_round_ready(inputs)
	if (locale === "uk") return uk_game_round_ready(inputs)
	if (locale === "vi") return vi_game_round_ready(inputs)
	if (locale === "zh") return zh_game_round_ready(inputs)
	return zh_hant_game_round_ready(inputs)
});